module.exports = __webpack_public_path__ + "static/em_capabilities_5-2827cd10d51bc6d543cd6f6fab0a2651.png";